export const syncEventsComplete = (message, reducers, data, connection) => {
  const { eventsDispatch } = reducers;
  eventsDispatch({ type: 'COMPLETE_POINT', payload: message.payload });
}